import React from 'react'
import { Settings, LogOut } from 'lucide-react'
import { useUser } from '@/providers/UserProvider'

export const UserMenu: React.FC = () => {
  const { user, showUserMenu, setShowUserMenu, logout } = useUser()

  if (!user)
    return (
      <div className="nav-item">
        <button
          className="nav-button"
          onClick={() => { window.location.href = '/api/auth/discord' }}
          aria-label="Se connecter avec Discord"
        >
          Se connecter
        </button>
      </div>
    )

  return (
    <div className="nav-item">
      <button
        className="nav-button user-button"
        onClick={() => setShowUserMenu(!showUserMenu)}
        aria-label="Menu utilisateur"
      >
        <div className="user-avatar">
          <span className="user-icon">{user.totemAnimal}</span>
        </div>
        <div className="user-info">
          <span className="user-name">{user.name}</span>
        </div>
      </button>

      {showUserMenu && (
        <div className="dropdown user-menu">
          <div className="user-profile">
            <div className="user-avatar-large">
              <span className="user-icon-large">{user.totemAnimal}</span>
            </div>
            <div className="user-details">
              <h4>{user.name}</h4>
            </div>
          </div>
          <div className="dropdown-divider" />
          <button className="dropdown-item">
            <Settings className="dropdown-icon" />
            <span>Paramètres</span>
          </button>
          <button
            className="dropdown-item dropdown-item--danger"
            onClick={logout}
          >
            <LogOut className="dropdown-icon" />
            <span>Déconnexion</span>
          </button>
        </div>
      )}
    </div>
  )
}
